import User from '@/models/User'

export default {

  fetchUserProfile () {
    const user = {
      socialid: null,
      provider: 'guest',
      avatar: null,
      optIn: false,
      email: null,
      name: 'Guest',
      surname: null,
      gender: null,
      location: null,
      rounds: []
    }
    const userProfile = new User(user)
    return userProfile
  }

}
